import src from "IMAGE";
export default { src, width: 1450, height: 536, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAR0lEQVR42jXKsQ1AUBRA0V+YQqPT2sQAEgOo6CQSlUjEAKIyjb2eo/jFudVNEXFyc3GwM/PwJimpaWjZWJno/iErGFkY6Kk++r5QsMJealYAAAAASUVORK5CYII="};
